import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import { phoneNumberClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/** Merchant POS — เฉพาะ login/session ไม่มี admin หรือ session permissions */
export const authClient = createAuthClient({
  baseURL: config.authUrl,
  plugins: [phoneNumberClient()],
});

export const profileApi = {
  async get() {
    return fetcher.get<{
      user: { id: string; name: string; email: string; image?: string | null };
    }>(`${config.apiUrl}/me`);
  },
  async update(form: FormData) {
    return fetcher.putForm<{ user: { id: string } }>(
      `${config.apiUrl}/me`,
      form,
    );
  },
};
